
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.115 88.372"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"right-quote(1)","fill":"#3d9ed3"}},[_c('path',{attrs:{"data-name":"Path 7055","d":"M63.627 49.488V0h49.488v50.195c0 33.935-31.814 38.176-31.814 38.176l-4.242-9.9s14.14-2.118 16.968-13.43c2.828-8.484-2.828-15.553-2.828-15.553H63.627z"}}),_c('path',{attrs:{"data-name":"Path 7056","d":"M0 49.488V0h49.488v50.195c0 33.935-31.814 38.176-31.814 38.176l-4.242-9.9s14.14-2.118 16.968-13.43c2.828-8.484-2.828-15.553-2.828-15.553H0z"}})])])
          )
        }
      }
    